function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("line", {
  x1: 12,
  y1: 2,
  x2: 12,
  y2: 6
});

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 12,
  y1: 18,
  x2: 12,
  y2: 22
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 4.93,
  y1: 4.93,
  x2: 7.76,
  y2: 7.76
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 16.24,
  y1: 16.24,
  x2: 19.07,
  y2: 19.07
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 2,
  y1: 12,
  x2: 6,
  y2: 12
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 18,
  y1: 12,
  x2: 22,
  y2: 12
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  x1: 4.93,
  y1: 19.07,
  x2: 7.76,
  y2: 16.24
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  x1: 16.24,
  y1: 7.76,
  x2: 19.07,
  y2: 4.93
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/loading.63c97283.svg";
export { SvgComponent as ReactComponent };